import { useState, useRef, useEffect } from 'react'

const xmlSerializer = new XMLSerializer()

const getSvgDataUri = (svgElement: SVGSVGElement): string => {
  if (!svgElement) return ''

  const svgString = xmlSerializer.serializeToString(svgElement)
  if (!svgString) return ''

  const encodedSvg = encodeURIComponent(svgString)
  if (!encodedSvg) return ''

  return `data:image/svg+xml;utf8,${encodedSvg}`
}

const useSvgDataUri = () => {
  const [uri, setUri] = useState('')
  const ref = useRef<SVGSVGElement | null>(null)

  useEffect(() => {
    if (ref.current) {
      const uri = getSvgDataUri(ref.current)
      setUri(uri)
    }
  }, [ref])

  return { uri, ref } as const
}

export default useSvgDataUri
